// Provedor de VoIP da empresa ativa e se ele está com a integração completa.
// Mesma regra usada pelo TaskModal (`hasVoipIntegration`): `Company.toJSON` apaga
// as colunas secretas e devolve `<campo>Configured`, então a presença de um
// campo é lida pelo valor OU por esse flag.
export function resolveVoipSetup(company) {
  const source = company || {};
  const provider = String(source.voipProvider || "vonage")
    .trim()
    .toLowerCase();

  const has = (field) => {
    if (String(source[field] || "").trim()) return true;
    return Boolean(source[`${field}Configured`]);
  };

  const isNvoip = provider === "nvoip";
  const isTwilio = provider === "twilio";
  const isZenvia = provider === "zenvia";
  const isIssabel = provider === "issabel";

  let configured;
  if (isNvoip) {
    configured =
      (has("nvoipApiToken") ||
        (has("nvoipSipUsername") && has("nvoipSipUserToken"))) &&
      has("nvoipCallerId");
  } else if (isZenvia) {
    configured = has("zenviaApiToken") && has("zenviaCallerId");
  } else if (isIssabel) {
    configured =
      has("issabelHost") &&
      has("issabelAmiUsername") &&
      has("issabelAmiPassword");
  } else if (isTwilio) {
    configured =
      has("twilioAccountSid") &&
      has("twilioAuthToken") &&
      has("twilioPhoneNumber") &&
      has("twilioApiKeySid") &&
      has("twilioApiKeySecret") &&
      has("twilioTwimlAppSid");
  } else {
    configured =
      has("vonageApplicationId") &&
      has("vonagePrivateKey") &&
      has("vonagePhoneNumber");
  }

  return {
    provider,
    isTwilio,
    // Twilio e Vonage ligam direto pelo navegador (WebRTC); Nvoip, Zenvia e
    // Issabel usam o fluxo de servidor (o backend liga primeiro para o agente).
    isServer: isNvoip || isZenvia || isIssabel,
    configured: Boolean(configured),
  };
}
